export const AUTH_TOKEN = '@dponet-backoffice-auth-token'
